import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {SecurityInterceptor} from './interceptors/security.interceptor';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: SecurityInterceptor, multi: true },
  ],
})
export class SecurityModule { }
